export const stackedAreaChartColors = [
  "#4285F4", // Google Blue
  "#EA4335", // Google Red
  "#FBBC05", // Google Yellow
  "#34A853", // Google Green
  "#8E24AA", // Purple
  "#00ACC1", // Cyan
  "#FB8C00", // Orange
  "#607D8B", // Blue Grey
  "#1E88E5", // Light Blue
  "#43A047", // Light Green
  "#E53935", // Red
  "#5E35B1", // Deep Purple
  "#F4511E", // Deep Orange
  "#3949AB", // Indigo
  "#00897B", // Teal
  "#C0CA33", // Lime
  "#6D4C41", // Brown
  "#546E7A", // Blue Grey (darker)
  "#D81B60", // Pink
  "#FFA000", // Amber
];
